import { makeAutoObservable } from 'mobx';
import axios from 'axios';
import i18n from '../i18n';

class LanguageStore {
  languages = [];
  selectedLanguage = 'en';
  loading = true;

  constructor() {
    makeAutoObservable(this);
    this.initialize();
  }

  async initialize() {
    await this.fetchLanguages();
    this.setLanguage('en');
    this.loading = false;
  }

  async fetchLanguages() {
    try {
      const response = await axios.get('https://api2.praguecoolpass.com/languages/active');
      this.languages = response.data;
    } catch (error) {
      console.error('Failed to fetch languages', error);
    }
  }

  setLanguage(languageCode) {
    this.selectedLanguage = languageCode;
    i18n.changeLanguage(languageCode);
  }
}

const languageStore = new LanguageStore();
export default languageStore;
